import React from 'react';
import { SpaceProps } from 'styled-system';
import Box from 'ui/Box';
import Tabs from '@ingka/tabs';
import useIsRtl from 'hooks/useIsRtl';

import '@ingka/svg-icon/dist/style.css';
import '@ingka/button/dist/style.css';
import '@ingka/carousel/dist/style.css';
import '@ingka/tabs/dist/style.css';
import '@ingka/focus/dist/style.css';

type Props = SpaceProps & {
  tabs?: React.ReactElement[];
  tabPanels?: React.ReactElement[];
  defaultActiveTab?: string;
  activeTab?: string;
  onTabChanged?: (...args: any[]) => any;
  rtl?: boolean;
};

const SkapaTabs = ({
  tabs,
  tabPanels,
  defaultActiveTab,
  activeTab,
  onTabChanged,
  ...props
}: Props) => {
  const rtl = useIsRtl();
  return (
    <Box {...props}>
      <Tabs
        activeTab={activeTab}
        defaultActiveTab={defaultActiveTab}
        onTabChanged={onTabChanged}
        tabs={tabs}
        tabPanels={tabPanels}
        rtl={rtl}
      ></Tabs>
    </Box>
  );
};

export default SkapaTabs;
